import React from "react";
import { Button, Row, Col, Icon } from "antd";
import "./campaign.css";

const CustomTemplate = props => {
  return (
    <div style={{ marginTop: 40 }}>
      <Row gutter={16}>
        <h2>Templates</h2>
        <Button
          style={{
            marginRight: 20,
            marginLeft: 20,
            width: 150,
            float: "right"
          }}
          type="primary"
          color="green"
          onClick={() => props.onCancel()}
        >
          Cancel
        </Button>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col span={6}>
          <Button
            className="blank-template"
            onClick={() => props.blankTemplate()}
          >
            <div className="template-container">
              <Icon style={{ fontWeight: "bold", fontSize: 50 }} type="plus" />
            </div>
          </Button>
        </Col>
        {/* {props.templates.length &&
          props.templates.map(template => (
            <Col key={template.id} span={6}>
              <Button
                type="link"
                className="image-button"
                onClick={() => props.loadCustomTemplate(template.design)}
              >
                <div className="template-container">
                  <img
                    alt="Campaign Icon"
                    src={template.image}
                    style={{ width: "80%" }}
                  />
                </div>
              </Button>
            </Col>
          ))} */}

        <Col span={6}>
          <Button
            type="link"
            className="image-button"
            onClick={() => props.loadCustomTemplate(props.templates.length &&
              props.templates[0].design)}
          >
            <div className="template-container">
              <img
                alt="Campaign Icon"
                src={props.templates.length &&
                  props.templates[0].image}
                style={{ width: "80%" }}
              />
            </div>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default CustomTemplate;
